import * as React from 'react';
import { NavLink } from 'react-router-dom';

interface HeaderLinkProps {
    url: string;
    label: string;
    newTab?: boolean;
    beta?: boolean;
}

export const HeaderLink = ({ url, label, newTab, beta }: HeaderLinkProps) => {
    if (beta) {
        return <NavLink to={url} className="font-weight-bold nav-link" style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }} activeClassName="active">
            <span>{label}</span>
            <p style={{ fontSize: '10px' }}>(beta)</p>
        </NavLink>
    }
    if (newTab) {
        return (
            <a href={url} className="font-weight-bold nav-link" target="_blank" rel="noopener noreferrer">
                {label}
            </a>
        );
    }
    return (
        <NavLink to={url} className="font-weight-bold nav-link" activeClassName="active">
            {label}
        </NavLink>
    );
}


// WEBPACK FOOTER //
// ./src/components/common/HeaderLink.tsx